export default "__VITE_ASSET__2c13300d__"